module.exports = __webpack_public_path__ + "img/0064.d3795d07.png";